import {z} from '@hono/zod-openapi';

export const composeMessageSourceSchema = z
  .object({
    context: z.enum([
      'CUSTOMER',
      'SERVICE_CASE',
      'SERVICE_ORDER',
      'BUSINESS_CASE',
      'RENTAL_ORDER',
      'VEHICLE',
      'INTEREST',
      'WORKSHOP_INTEREST',
    ]),
    recordId: z.string().uuid(),
    customerId: z.string().uuid().optional(),
    /** An inbound customer e-mail the message answers; the DMS authorizes and quotes it. */
    replyToMessageId: z.string().uuid().optional(),
  })
  .strict()
  .openapi('ComposeMessageSource');

export type ComposeMessageSource = z.infer<typeof composeMessageSourceSchema>;
